export default "__VITE_ASSET__19077506__"